import styled, { css } from 'styled-components';

import Message from '../ui/Message';

export default styled.div``;

export const CampsitePriceWrapper = styled.div`
  display: flex;
  font-size: 1rem;
`;

export const CampsitePrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  padding: 0.5rem;
  flex: 1;
  text-align: center;

  ${({ selected, theme }) => selected && css`
    background-color: ${theme.COLOR_GRAY_LIGHTER};
  `}
`;

export const ToursPrice = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`;

export const Price = styled.div`
  display: flex;
  gap: 0.25rem;
  font-weight: 700;

  ${({ inline }) => inline && css`
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  `}
`;

export const CampsiteMembershipPrice = styled(CampsitePrice)``;

export const Closed = styled(Message)`
  background-color: ${({ theme }) => theme.COLOR_WARNING};
  color: ${({ theme }) => theme.COLOR_WHITE};
`;

export const Error = styled(Message)`
  background-color: ${({ theme }) => theme.COLOR_DANGER};
  color: ${({ theme }) => theme.COLOR_WHITE};
`;

export const Full = styled(Message)`
  background-color: ${({ theme }) => theme.COLOR_INFO};
  color: ${({ theme }) => theme.COLOR_WHITE};
`;

export const PriceLabel = styled.div`
  font-weight: 700;
`;

export const FromLabel = styled.span`
  font-weight: 400;
`;

export const FromPrice = styled.div`
  font-weight: 700;
`;
